module.exports = (window.Handlebars["default"] || window.Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<span class=\"badge badge-dark w-100\" style=\"background-color: "
    + alias2(alias1((depth0 != null ? depth0.color : depth0), depth0))
    + ";\">"
    + alias2(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</span>";
},"useData":true})